import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Mail, MapPin, Phone, Facebook } from "lucide-react";
import { useContent } from "@/context/ContentContext";
import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function Footer() {
  const { content } = useContent();
  const [store, setStore] = useState({
    store_name: "Au and Co.",
    tagline: "Materiais para quem cria.",
    email: "",
    phone: "",
    address: "",
    instagram: "",
    facebook: "",
  });

  useEffect(() => {
    api.get("/settings").then(({ data }) => setStore((cur) => ({ ...cur, ...data }))).catch(() => {});
  }, []);

  const footer = content.footer || {};
  const cols = footer.columns || [];
  const brandName = content.header?.logo_text || store.store_name || "Au and Co.";

  return (
    <footer className="brand-surface mt-32" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-20">
        <div className={`grid grid-cols-1 md:grid-cols-${Math.min(4, 2 + cols.length)} gap-12`}>
          <div>
            <h3 className="font-serif text-3xl brand-text mb-4">{brandName}</h3>
            <p className="text-sm brand-muted leading-relaxed">{store.tagline}</p>
          </div>

          {cols.map((col, i) => (
            <div key={i}>
              <p className="label-sm mb-4">{col.title}</p>
              <ul className="space-y-2 text-sm">
                {(col.links || []).map((l, j) => {
                  const isExternal = l.url && (l.url.startsWith("http") || l.url === "#");
                  return (
                    <li key={j}>
                      {isExternal ? (
                        <a href={l.url} className="brand-text hover:brand-primary-text">{l.label}</a>
                      ) : (
                        <Link to={l.url || "/"} className="brand-text hover:brand-primary-text">{l.label}</Link>
                      )}
                    </li>
                  );
                })}
              </ul>
            </div>
          ))}

          <div>
            <p className="label-sm mb-4">Contacto</p>
            <ul className="space-y-3 text-sm brand-muted">
              {store.email && <li className="flex items-center gap-2"><Mail size={14} /> {store.email}</li>}
              {store.phone && <li className="flex items-center gap-2"><Phone size={14} /> {store.phone}</li>}
              {store.address && <li className="flex items-center gap-2"><MapPin size={14} /> {store.address}</li>}
              {store.instagram && <li className="flex items-center gap-2"><Instagram size={14} /> {store.instagram}</li>}
              {store.facebook && <li className="flex items-center gap-2"><Facebook size={14} /> {store.facebook}</li>}
            </ul>
          </div>
        </div>

        <div className="border-t brand-border mt-16 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs brand-muted">© {new Date().getFullYear()} {brandName}. Todos os direitos reservados.</p>
          {footer.payment_line && <p className="text-xs brand-muted">{footer.payment_line}</p>}
        </div>
      </div>
    </footer>
  );
}
